function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4d4d4f}.cls-3{fill:#f26524}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  fill: "#f0e2db",
  d: "M3.6 0h22.8A3.6 3.6 0 0 1 30 3.6v22.8a3.6 3.6 0 0 1-3.6 3.6H3.6A3.6 3.6 0 0 1 0 26.4V3.6A3.6 3.6 0 0 1 3.6 0z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "help",
  transform: "translate(7 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_523",
  d: "M93 200.985l-3-5.279.336-.706h1.119v.291l2.82 5.018z",
  className: "cls-2",
  transform: "translate(-90 -185.825)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_524",
  d: "M333.109 200.985l-1.277-.676 2.82-5.018V195h.756l.7.706z",
  className: "cls-2",
  transform: "translate(-320.107 -185.825)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  d: "M23465.912 17264.854H23455v-2.115a7.868 7.868 0 0 1 7.229-7.732h.736c.23 0 .727-.008.727-.008a7.878 7.878 0 0 1 7.309 7.74v2.115z",
  className: "cls-3",
  transform: "translate(-23455 -17254.973)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  fill: "#ffcab2",
  d: "M23457.91 17264.887h-2.91v-.945a17.326 17.326 0 0 1 1.211-6.371l.93-2.531c.252-.023.51-.035.768-.035a6.813 6.813 0 0 1 .693.027l1.008 2.539a17.4 17.4 0 0 1 1.207 6.371v.945z",
  transform: "translate(-23449.908 -17255.004)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_626",
  fill: "#fff",
  d: "M1.333 0h8a1.333 1.333 0 0 1 1.333 1.333v8a1.333 1.333 0 0 1-1.333 1.333h-8A1.333 1.333 0 0 1 0 9.333v-8A1.333 1.333 0 0 1 1.333 0z",
  transform: "translate(2.667 13.334)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  d: "M23457 17259h-.664v-1.338H23455v-1.328h1.334V17255h1.336v1.336h1.33v1.328h-1.332v1.336z",
  className: "cls-3",
  transform: "translate(-23449 -17238.332)"
}));

function SvgColorIconDistributor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_hospital",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconDistributor);
export default __webpack_public_path__ + "static/media/colorIconDistributor.b26b4dbc.svg";
export { ForwardRef as ReactComponent };